import {
  GetCatalogProductsListResponseSchema,
  type GetCatalogProductsListResponse,
} from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomBaseUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useCatalogProductsList(options?: CustomBaseUseQueryOptions<GetCatalogProductsListResponse>) {
  return useQuery(
    queryKeys.catalogProducts(),
    async () => {
      const api = getPrivateApi();
      const getCatalogProductsListResponse = await api.getCatalogProductsList();

      return GetCatalogProductsListResponseSchema.parse(getCatalogProductsListResponse);
    },
    { suspense: true, ...options },
  );
}
